/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo } from 'react';

import { useQuery } from '@tanstack/react-query';

import { IXOneGridHierarchy } from './IXOneCreditCard';
import { IXOneHierarchyAction } from '../ixone-section/IXOneHierarchyAction';

import { StatusPaidProduct, StatusUnpaidProduct } from '../make-product-active';

import { getUserCardEula } from 'services/payment';

const MONEY_UNIT = '$';

export const useIXOneColumns = ({
                                  isActiveProduct = false,
                                  selectedHierarchies = {},
                                }) => {
  // Prevent cellRenderer from being re-rendered, which causes the visible state to reset

  const columns = useMemo(
    () => [
      {
        field: 'gtin',
        displayName: 'GTIN',
      },
      {
        field: 'upc12',
        displayName: 'UPC12',
      },
      {
        field: 'productName',
        displayName: 'Product Name',
        flex: 1,
      },
      {
        field: 'packageLevel',
        displayName: 'Package Level',
        maxWidth: 160,
      },
      ...(isActiveProduct
        ? [
          {
            field: 'statusCharge',
            displayName: 'Status',
            maxWidth: 100,
            cellRenderer: (params) => {
              const isPaid = Boolean(params?.data?.isPaid);

              return (
                <>
                  {isPaid ? <StatusPaidProduct/> : <StatusUnpaidProduct/>}
                </>
              );
            },
          },
        ]
        : [
          {
            field: 'packDescription',
            displayName: 'Pack',
            maxWidth: 100,
            cellRenderer: (params) => {
              return params?.value ?? 'N/A';
            },
          },
          {
            field: 'hierarchies',
            displayName: 'Hierarchy',
            maxWidth: 120,
            cellRenderer: (params) => {
              const productId = params?.data?.productId;

              const selectedHierarchy =
                selectedHierarchies?.[productId]?.selectedHierarchy ?? {};

              const isHasHierarchies =
                Object.keys(selectedHierarchy).length > 0;

              return (
                <IXOneGridHierarchy value={isHasHierarchies ? 'Yes' : 'No'}>
                  <IXOneHierarchyAction
                    productId={params?.data?.productId}
                    productName={params?.data?.productName}
                    key={params?.data?.productId}
                    hierarchies={params?.data?.hierarchies ?? []}
                  />
                </IXOneGridHierarchy>
              );
            },
          },
        ]),
      {
        field: 'fee',
        displayName: 'Fee',
        maxWidth: 120,
        cellRenderer: (params) => {
          return `${MONEY_UNIT}${params?.value}`;
        },
      },
    ],
    [JSON.stringify(selectedHierarchies), isActiveProduct]
  );

  return {
    columns,
  };
};

export const useGetUserEulaCard = () => {
  const query = useQuery({
    queryKey: ['credit-card', 'get-user-eula-car'],
    queryFn: getUserCardEula,
  });

  return {
    eulaContent: query?.data?.data?.cardEulaContent,
    ...query,
  };
};
